const ManageLocumPage = () => {
  return (
    <div>
      <h1>Manage Locum</h1>
    </div>
  );
};

export default ManageLocumPage;
